import { memo } from "react";

const RESUNAIcon = (props) => {
  const { color = "#666666", size = 15 } = props;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M30.5 26C31.8807 26 33 24.8807 33 23.5C33 22.1193 31.8807 21 30.5 21C29.1193 21 28 22.1193 28 23.5C28 24.8807 29.1193 26 30.5 26Z" fill={color} />
      <path fillRule="evenodd" clipRule="evenodd" d="M8 7C8 5.34315 9.34315 4 11 4H37C38.6569 4 40 5.34315 40 7V44H8V7ZM11 7H37V41H11V7Z" fill={color} />
    </svg>
  );
};

export default memo(RESUNAIcon);
